import React from 'react';
import PropTypes from 'prop-types';

const isDesktop = () => {
    return window.matchMedia("(min-width: 769px)").matches
};
const SliderItem = ({ mobileImage, image, ctaButtonText, ctaButtonUrl = '', bodyContent, isExternal }) => {
    return (<a href={ctaButtonUrl} target={`${isExternal ? '__blank': ''}`}>
        <div className="single-slider" style={{
            backgroundImage: `url(${mobileImage ? (isDesktop ? image : mobileImage) : image})`,
        }}>
            <div className="container">
                <div className="row">
                    <div className="col-md-12 col-lg-12 banner-text wow fadeInUp">
                        {bodyContent}
                        {ctaButtonText && <a className="banner-btn" href={ctaButtonUrl} target={`${isExternal ? '__blank': ''}`}>{ctaButtonText}</a>}
                    </div>
                </div>
            </div>
        </div>
        </a>
    )
};



SliderItem.propTypes = {
    image: PropTypes.string,
    mobileImage: PropTypes.string,
    ctaButtonText: PropTypes.string,
    ctaButtonUrl:PropTypes.string,
    bodyContent: PropTypes.any,
    isExternal:PropTypes.bool,
};
export default SliderItem;


// WEBPACK FOOTER //
// ./src/components/Slider/SliderItem.jsx